import { PresetMedia } from '@nucleus/types/web';

export const blockBackground: PresetMedia = {
  mediaOptions: {
    blending: {
      fade: 'none',
      opacity: 1,
      blendMode: 'none',
      fadeIntensity: 0.5,
    },
    image: {
      tile: 'none',
      scale: 'cover',
    },
    video: {
      image: {
        tile: 'none',
        scale: 'cover',
      },
    },
    useColor: false,
  },
};
